import f from "react";
import A from "pretty-bytes";
import { styled as L } from "@mui/material/styles";
import { jsxs as F, jsx as l } from "react/jsx-runtime";
import N from "@mui/icons-material/AttachFile";
import w from "@mui/icons-material/Close";
import R from "@mui/material/IconButton";
import x from "@mui/material/InputAdornment";
import $ from "@mui/material/TextField";
import B from "@mui/material/Typography";
const j = L("label")`
  position: relative;
  flex-grow: 1;

  input {
    opacity: 0 !important;
  }

  span {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 2;
    display: flex;
    align-items: center;
  }

  span.MuiFileInput-placeholder {
    color: gray;
  }
`, E = {
  Label: j
}, O = f.forwardRef((t, e) => {
  const {
    text: n,
    isPlaceholder: i,
    placeholder: s,
    ...a
  } = t, o = f.useId();
  return /* @__PURE__ */ F(E.Label, {
    htmlFor: o,
    children: [/* @__PURE__ */ l("input", {
      ...a,
      ref: e,
      id: o
    }), n ? /* @__PURE__ */ l("span", {
      "aria-placeholder": s,
      className: i ? "MuiFileInput-placeholder" : "",
      children: n
    }) : null]
  });
});
function k(t) {
  return t.length > 0;
}
function D(t) {
  return t.reduce((e, n) => e + n.size, 0);
}
function c(t) {
  return typeof window < "u" && t instanceof File;
}
function K(t) {
  return Array.from(t);
}
function V(t, e) {
  if (t.length < e)
    return t;
  const i = Math.floor((e - 1) / 2);
  return `${t.slice(0, i)}\u2026${t.slice(
    t.length - i
  )}`;
}
function _(t) {
  const {
    value: e,
    onChange: n,
    disabled: i,
    getInputText: s,
    getSizeText: a,
    placeholder: o,
    hideSizeText: T,
    inputProps: m,
    InputProps: u,
    multiple: d,
    className: z,
    ...P
  } = t, h = f.useRef(null), y = d || m?.multiple || u?.inputProps?.multiple || !1, b = () => {
    const r = h.current;
    r && (r.value = "");
  }, v = (r) => {
    const g = r.target.files, I = g ? K(g) : [];
    b(), n?.(y ? I : I[0]);
  }, C = (r) => {
    r.preventDefault(), !i && n?.(d ? [] : null);
  }, p = Array.isArray(e) ? k(e) : c(e), M = () => {
    if (e === null || Array.isArray(e) && e.length === 0)
      return o || "";
    if (typeof s == "function" && e !== void 0)
      return s(e);
    if (e && p) {
      if (Array.isArray(e) && e.length > 1)
        return `${e.length} files`;
      const r = c(e) ? e.name : e[0]?.name || "";
      return V(r, 20);
    }
    return "";
  }, S = () => {
    if (typeof a == "function" && e !== void 0)
      return a(e);
    if (p) {
      if (Array.isArray(e)) {
        const r = D(e);
        return A(r);
      }
      if (c(e))
        return A(e.size);
    }
    return "";
  };
  return /* @__PURE__ */ l($, {
    type: "file",
    disabled: i,
    onChange: v,
    className: `MuiFileInput-TextField ${z || ""}`,
    InputProps: {
      startAdornment: /* @__PURE__ */ l(x, {
        position: "start",
        children: /* @__PURE__ */ l(N, {})
      }),
      endAdornment: /* @__PURE__ */ F(x, {
        position: "end",
        style: {
          visibility: p ? "visible" : "hidden"
        },
        children: [T ? null : /* @__PURE__ */ l(B, {
          variant: "caption",
          mr: "2px",
          className: "MuiFileInput-Typography-size-text",
          children: S()
        }), /* @__PURE__ */ l(R, {
          "aria-label": "Clear",
          title: "Clear",
          size: "small",
          disabled: i,
          className: "MuiFileInput-IconButton",
          onClick: C,
          children: /* @__PURE__ */ l(w, {
            fontSize: "small"
          })
        })]
      }),
      ...u,
      inputProps: {
        text: M(),
        multiple: y,
        isPlaceholder: e === null || Array.isArray(e) && e.length === 0,
        ref: h,
        placeholder: o,
        ...m,
        ...u?.inputProps
      },
      inputComponent: O
    },
    ...P
  });
}
export {
  _ as MuiFileInput
};
